(function () {
  angular.module('MktzapApp.Factories')
    .factory('ProfilePermissionControlService', ProfilePermissionControlService);

  ProfilePermissionControlService.$inject = ['$resource'];

  function ProfilePermissionControlService($resource) {
    return $resource(apiUrl + '/profile-permission-control', {}, {
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      registerModule: { url: apiUrl + '/profile-permission-control/module', method: 'POST', params: {}, isArray: false },
      updateModule: { url: apiUrl + '/profile-permission-control/module', method: 'PATCH', params: {}, isArray: false },
      deleteModule: { url: apiUrl + '/profile-permission-control/module', method: 'DELETE', params: {}, isArray: false },

      registerSubModule: { url: apiUrl + '/profile-permission-control/subModule', method: 'POST', params: {}, isArray: false },
      updateSubModule: { url: apiUrl + '/profile-permission-control/subModule', method: 'PATCH', params: {}, isArray: false },
      deleteSubModule: { url: apiUrl + '/profile-permission-control/subModule', method: 'DELETE', params: {}, isArray: false },

      registerAction: { url: apiUrl + '/profile-permission-control/action', method: 'POST', params: {}, isArray: false },
      updateAction: { url: apiUrl + '/profile-permission-control/action', method: 'PATCH', params: {}, isArray: false },
      deleteAction: { url: apiUrl + '/profile-permission-control/action', method: 'DELETE', params: {}, isArray: false },

      getLinkedPermissions: { url: apiUrl + '/profile-permission-control/permissions', method: 'GET', params: {}, isArray: false },
    });
  }
})();